// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ZVSPL","title":"Header_title__1T2sb","left":"Header_left__21fo5","clinicName":"Header_clinicName__MaNRD"};